import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, CircularProgress } from '@mui/material';
import Countdown from 'react-countdown';
import { motion } from 'framer-motion';
import { requestUrl } from '../requestUrl';

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return (
      <Typography variant="h4" align="center" sx={{ color: '#2e7d32', fontWeight: 'bold' }}>
        倒计时结束 🎉
      </Typography>
    );
  }

  const items = [
    { label: '天', value: days },
    { label: '小时', value: hours },
    { label: '分钟', value: minutes },
    { label: '秒', value: seconds }
  ];

  return (
    <Box display="flex" gap={2} justifyContent="center" mt={2} flexWrap="wrap">
      {items.map((item, index) => (
        <motion.div
          key={index}
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
        >
          <Box
            sx={{
              background: 'linear-gradient(145deg, #1976d2, #5c6bc0)',
              color: '#fff',
              borderRadius: 4,
              padding: 2,
              minWidth: 80,
              textAlign: 'center',
              boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
              transition: 'transform 0.3s',
              '&:hover': {
                transform: 'scale(1.05)',
              },
            }}
          >
            <Typography variant="h4" fontWeight="bold" sx={{ letterSpacing: 1 }}>
              {String(item.value).padStart(2, '0')}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                fontStyle: 'italic',
                color: '#ffeb3b',
              }}
            >
              {item.label}
            </Typography>
          </Box>
        </motion.div>
      ))}
    </Box>
  );
};

export default function CoolCountdown() {
  const [correctedTarget1, setCorrectedTarget1] = useState(null);
  const [correctedTarget2, setCorrectedTarget2] = useState(null);
  const [cspjstitle1, setCspjstitle1] = useState('');
  const [cspjstitle2, setCspjstitle2] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await requestUrl({ id: 1 }, 'get_csp_time');
        if (data.status === 'success') {
          console.log(data);
          const serverTime = new Date(data.serverNow);
          const offset = Date.now() - serverTime.getTime();

          const time1 = new Date(data.cspjstime1);
          setCorrectedTarget1(time1.getTime() + offset);
          setCspjstitle1(data.cspjstitle1);

          const time2 = new Date(data.cspjstime2);
          setCorrectedTarget2(time2.getTime() + offset);
          setCspjstitle2(data.cspjstitle2);
        }
      } catch (error) {
        console.error('获取数据时出错:', error);
      }
    };
    fetchData();
  }, []);

  const countdowns = [
    { title: cspjstitle1, target: correctedTarget1 },
    { title: cspjstitle2, target: correctedTarget2 }
  ];

  return (
    <Box sx={{ maxWidth: 500, mx: 'auto', mt: 6, px: 2 }}>
      {countdowns.map((item, idx) => (
        <Card
          key={idx}
          sx={{
            mb: 5,
            p: 2,
            background: 'linear-gradient(135deg, #e3f2fd, #bbdefb)',
            borderRadius: 5,
            boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
          }}
        >
          <CardContent>
            <Typography
              variant="h5"
              align="center"
              gutterBottom
              sx={{
                color: '#1976d2',
                borderBottom: '2px dashed #1976d2',
                pb: 1,
                mb: 2,
                fontWeight: 'bold',
                display: 'inline-block',
              }}
            >
              ⏳ {item.title || '加载中...'}
            </Typography>

            {item.target ? (
              <Countdown date={item.target} renderer={renderer} />
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                mt={3}
                sx={{
                  backgroundColor: 'rgba(0,0,0,0.05)',
                  py: 4,
                  borderRadius: 3,
                }}
              >
                <CircularProgress color="primary" />
              </Box>
            )}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}
